import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-file-previewer-dialog',
    templateUrl: './file-previewer-dialog.component.html',
    styleUrls: ['./file-previewer-dialog.component.scss'],
})
export class FilePreviewerDialogComponent {
    @Input() data: string;
    @Input() fileName?: string;
    @Input() type?: string;

    constructor(private activeModal: NgbActiveModal) {}

    dismiss(reason: string): void {
        this.activeModal.dismiss(reason);
    }
}
